import { usePermissions } from '~/composables/use-permissions';

export default defineNuxtRouteMiddleware(() => {
  const { hasUploadDataPermission } = usePermissions();

  if (!hasUploadDataPermission.value) {
    return abortNavigation({ statusCode: 404 });
  }
});
